<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">Daily Purchase</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-print"></i> {{$t('print')}}</button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="date" class="form-control form-control-sm" v-model="query.FromDate" />
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="date" class="form-control form-control-sm" v-model="query.ToDate" />
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <AuthCompleted @select="onSelect" :place="$t('all')" :is-include-all="true"></AuthCompleted>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-striped table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center">{{$t('no')}}</th>
                                        <th>{{$t('code')}}</th>
                                        <th>{{$t('name')}}</th>
                                        <th>{{$t('invoice_no')}}</th>
                                        <th>{{$t('date')}}</th>
                                        <th class="text-center" style="width: 100px;">{{$t('qty')}}</th>
                                        <th style="width: 100px;">{{$t('uom')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in records" :key="index">
                                        <td class="text-center">{{index+1}}</td>
                                        <td>{{ret.ItemCode}}</td>
                                        <td>{{ret.ItemName}}</td>
                                        <td>{{ret.InvoiceNum}}</td>
                                        <td>{{$format(ret.InvoiceDate, 'DD-MM-YYYY')}}</td>
                                        <td class="text-center">{{ret.Quantity}}</td>
                                        <td>{{ret.UomName}}</td>
                                    </tr>
                                </tbody>
                                <tfoot v-if="query.ItemId!=''">
                                    <tr>
                                        <th colspan="5" class="text-right">{{$t('total')}}</th>
                                        <th class="text-center">{{getTotal}}</th>
                                        <th></th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { AuthCompleted } from '../../Item';
    export default {
        components: { AuthCompleted },
        data() {
            return {
                query: {
                    FromDate: this.$now().format('YYYY-MM-DD'),
                    ToDate: this.$now().format('YYYY-MM-DD'),
                    ItemId: '',
                    CompanyId: this.$store.state.company.Id
                },
                records: []
            }
        },
        created() {
            this.toList();
        },
        methods: {
            toList() {
                var loading = this.$loading.show();
                this.$api().post('report/purchase/invoice/item/daily', this.query).then(res => {
                    if (this.$isValid(res)) {
                        this.records = res.data.Json.Result;
                    }
                }).finally(function () { loading.hide(); });
            },
            onSelect(e) {
                if (e == null) this.query.ItemId = '';
                else this.query.ItemId = e.Id;
                this.toList();
            }
        },
        computed: {
            getTotal() {
                var res = 0;
                this.records.map(value => {
                    res += value.Quantity;
                });
                return res;
            }
        }
    }
</script>
